import { render } from "./RecommendNewMailProperties.vue?vue&type=template&id=468f57ea"
import script from "./RecommendNewMailProperties.vue?vue&type=script&lang=js"
export * from "./RecommendNewMailProperties.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__